(function () {
  if (window.__kmBlogAttributionInitialized) return;
  window.__kmBlogAttributionInitialized = true;

  var root = document.querySelector('[data-blog-attribution-root]');
  if (!root) return;

  window.dataLayer = window.dataLayer || [];

  var STORAGE_KEY = 'km_blog_attribution_v1';
  var SESSION_KEY = 'km_blog_session_id';
  var observedCtas = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var observedNewsletters = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  var ctaPositions = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  var nextPosition = 1;

  function getData(el, key) {
    return el && el.dataset ? el.dataset[key] || '' : '';
  }

  function getArticleData() {
    return {
      article_id: getData(root, 'articleId'),
      article_handle: getData(root, 'articleHandle'),
      article_title: getData(root, 'articleTitle'),
      blog_handle: getData(root, 'blogHandle'),
      article_url: getData(root, 'articleUrl'),
      page_path: window.location.pathname
    };
  }

  function pushEvent(eventName, payload) {
    var eventPayload = payload || {};
    eventPayload.event = eventName;
    window.dataLayer.push(eventPayload);
  }

  function getUrlPath(targetUrl) {
    if (!targetUrl) return '';

    try {
      return new URL(targetUrl, document.baseURI).pathname;
    } catch (error) {
      return '';
    }
  }

  function classifyCommerceAttribution(data) {
    var path = getUrlPath(data.cta_target_url);

    if (path.indexOf('/products/') === 0) return 'product_target_url';
    if (path.indexOf('/collections/') === 0) return 'collection_target_url';
    if (data.cta_type === 'quiz_result_product' || data.cta_action === 'quiz-result-product') {
      return 'quiz_product_recommendation';
    }
    if (data.cta_type === 'banner' && (path.indexOf('/products/') === 0 || path.indexOf('/collections/') === 0)) {
      return 'banner_commerce';
    }

    return '';
  }

  function enrichAttributionData(data) {
    var attributionReason = classifyCommerceAttribution(data);
    data.commerce_eligible = Boolean(attributionReason);
    data.attribution_reason = attributionReason || 'engagement_only';
    return data;
  }

  function getSessionId() {
    var fallback = 'blog-' + Date.now() + '-' + Math.random().toString(36).slice(2);

    try {
      var existing = window.localStorage.getItem(SESSION_KEY);
      if (existing) return existing;
      window.localStorage.setItem(SESSION_KEY, fallback);
    } catch (error) {
      return fallback;
    }

    return fallback;
  }

  function getCtaPosition(cta) {
    if (!ctaPositions) return 0;
    if (!ctaPositions.has(cta)) {
      ctaPositions.set(cta, nextPosition);
      nextPosition += 1;
    }
    return ctaPositions.get(cta);
  }

  function getCtaData(cta, actionEl) {
    var articleData = getArticleData();
    var data = {
      cta_context: 'blog',
      cta_type: getData(cta, 'ctaType'),
      cta_id: getData(cta, 'ctaId'),
      cta_action: getData(actionEl, 'ctaAction') || getData(cta, 'ctaAction'),
      cta_target_url: getData(actionEl, 'ctaTargetUrl') || getData(cta, 'ctaTargetUrl'),
      product_id: getData(cta, 'productId'),
      product_handle: getData(cta, 'productHandle'),
      variant_id: getData(cta, 'variantId'),
      position: getCtaPosition(cta)
    };

    if (!data.cta_target_url && actionEl && actionEl.href) {
      data.cta_target_url = actionEl.href;
    }

    Object.keys(articleData).forEach(function (key) {
      data[key] = articleData[key];
    });

    return data;
  }

  function updateCartAttributes(data) {
    if (!data || !data.commerce_eligible) return;

    var attributes = {
      blog_cta_ref: [data.article_handle, data.cta_id].filter(Boolean).join('|'),
      blog_cta_ts: data.ts || new Date().toISOString(),
      blog_article: data.article_handle || '',
      blog_session_id: data.session_id || getSessionId(),
      blog_attribution_reason: data.attribution_reason || ''
    };

    try {
      window.fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function () {});
    } catch (error) {}
  }

  function persistAttribution(data) {
    var timestamp = new Date().toISOString();
    var sessionId = getSessionId();
    enrichAttributionData(data);

    var stored = {
      version: 1,
      article_handle: data.article_handle,
      article_title: data.article_title,
      blog_handle: data.blog_handle,
      cta_id: data.cta_id,
      cta_type: data.cta_type,
      cta_action: data.cta_action,
      cta_target_url: data.cta_target_url,
      product_id: data.product_id,
      product_handle: data.product_handle,
      variant_id: data.variant_id,
      commerce_eligible: data.commerce_eligible,
      attribution_reason: data.attribution_reason,
      ts: timestamp,
      session_id: sessionId
    };

    data.ts = timestamp;
    data.session_id = sessionId;

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
    } catch (error) {}
  }

  function isInternalUrl(targetUrl) {
    if (!targetUrl) return false;

    try {
      var url = new URL(targetUrl, document.baseURI);
      var host = url.hostname;
      return host === window.location.hostname || host === 'kumikomatcha.fr' || /\.myshopify\.com$/.test(host);
    } catch (error) {
      return false;
    }
  }

  function addBlogCtaParam(targetUrl, ctaId) {
    if (!targetUrl || !ctaId || !isInternalUrl(targetUrl)) return targetUrl;

    try {
      var url = new URL(targetUrl, document.baseURI);
      if (!url.searchParams.has('km_blog_cta')) {
        url.searchParams.set('km_blog_cta', ctaId);
      }
      return url.toString();
    } catch (error) {
      return targetUrl;
    }
  }

  function pushQuizStart(data) {
    pushEvent('blog_quiz_start', {
      cta_context: data.cta_context,
      cta_type: data.cta_type,
      cta_id: data.cta_id,
      article_id: data.article_id,
      article_handle: data.article_handle,
      article_title: data.article_title,
      blog_handle: data.blog_handle,
      position: data.position
    });
  }

  function handleClick(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var actionEl = target.closest('[data-cta-action]');
    var cta = target.closest('[data-cta-type][data-cta-id]');

    if (!cta || !root.contains(cta)) return;
    if (!actionEl && getData(cta, 'ctaAction')) actionEl = cta;
    if (!actionEl && !getData(cta, 'ctaTargetUrl')) return;

    var data = getCtaData(cta, actionEl || cta);
    enrichAttributionData(data);
    pushEvent('cta_click', data);
    persistAttribution(data);

    if (data.commerce_eligible && data.cta_action === 'add-to-cart') {
      updateCartAttributes(data);
    }

    if (data.cta_type === 'quizz' || data.cta_action === 'quiz-start') {
      pushQuizStart(data);
    }

    if (actionEl && actionEl.tagName === 'A') {
      actionEl.href = addBlogCtaParam(actionEl.href, data.cta_id);
      return;
    }

    if (actionEl === cta && data.cta_target_url) {
      event.preventDefault();
      event.stopPropagation();
      window.location.href = addBlogCtaParam(data.cta_target_url, data.cta_id);
    }
  }

  function handleSubmit(event) {
    var form = event.target;
    if (!form || !form.closest) return;

    var cta = form.closest('[data-cta-type][data-cta-id]');
    if (!cta || !root.contains(cta) || getData(cta, 'ctaType') !== 'newsletter') return;

    var data = getCtaData(cta, form);
    data.cta_action = data.cta_action || 'newsletter-submit';
    enrichAttributionData(data);
    pushEvent('blog_newsletter_submit', data);
    persistAttribution(data);
  }

  function isVisible(el) {
    if (!el) return false;
    if (el.hidden) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;

    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function observeNewsletterSuccess(cta) {
    if (getData(cta, 'ctaType') !== 'newsletter') return;
    if (observedNewsletters && observedNewsletters.has(cta)) return;
    if (observedNewsletters) observedNewsletters.add(cta);

    var fired = false;
    var successEl = cta.querySelector('.article__msn-success, .note--success');

    function maybePushSuccess() {
      if (fired) return;
      successEl = successEl || cta.querySelector('.article__msn-success, .note--success');
      if (!isVisible(successEl)) return;

      fired = true;
      var data = getCtaData(cta, successEl);
      data.cta_action = 'newsletter-success';
      pushEvent('blog_newsletter_success', data);
    }

    maybePushSuccess();

    if (!window.MutationObserver) return;

    var observer = new MutationObserver(maybePushSuccess);
    observer.observe(cta, {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: ['hidden', 'style', 'class', 'aria-hidden']
    });
  }

  function registerCta(cta, observer) {
    if (observedCtas && observedCtas.has(cta)) return;
    if (observedCtas) observedCtas.add(cta);

    getCtaPosition(cta);
    observeNewsletterSuccess(cta);

    if (observer) {
      observer.observe(cta);
    } else {
      pushEvent('blog_cta_impression', getCtaData(cta, cta));
    }
  }

  function scanCtas(observer) {
    var ctas = root.querySelectorAll('[data-cta-type][data-cta-id]');
    Array.prototype.forEach.call(ctas, function (cta) {
      registerCta(cta, observer);
    });
  }

  pushEvent('blog_article_view', getArticleData());

  var impressionObserver = null;
  if ('IntersectionObserver' in window) {
    impressionObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          pushEvent('blog_cta_impression', getCtaData(entry.target, entry.target));
          impressionObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.35 }
    );
  }

  scanCtas(impressionObserver);

  if (window.MutationObserver) {
    new MutationObserver(function () {
      scanCtas(impressionObserver);
    }).observe(root, { childList: true, subtree: true });
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('submit', handleSubmit, true);
})();
